import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";

type Props = {
  path?: string;
  heading?: string;
  paragraph?: string;
  className?: string;
  ImgClass?: string;
  TopClass?: string;
  headingClass?: string;
  paragraphClass?: string;
  explore?: string;
  to?: any;
};

const GraphDataOnLeft = ({
  path,
  heading,
  paragraph,
  className,
  ImgClass,
  TopClass,
  headingClass,
  paragraphClass,
  explore,
  to,
}: Props) => {
  return (
    <div className={`${className} section3 container px-30`}>
      <div className="row card-container1 col-md-12 col-sm-12 col-lg-12 ">
        {/* <div className="col-md-1" /> */}
        <div
          className={`$ row col-lg-6 col-md-12 container-fluid align-self-center p-10`}
        >
          <p
            className={`${headingClass} font-26 font-family-roboto-flex fonts-800 line-30 pb-20 text-white-color garph-heading`}
          >
            {heading}
          </p>
          <p
            className={`${paragraphClass} text-white-20 font-family-roboto font-16 fonts-400 pb-20 line-18 graph-subheading`}
          >
            {paragraph}
          </p>
          <div className="d-block d-md-none">
            {/* mobile */}
            {explore && (
              <Link to={to}>
                {" "}
                <div className="expoler-btn">
                  <Button
                    textclass="fonts-500 font-family-roboto-flex font-16 line-18 justify-content-center"
                    className="text-color-success wx-90 hx-30 d-flex align-items-center justify-content-center d-block d-md-none"
                    text={explore}
                  />
                </div>
              </Link>
            )}
          </div>
          <div className="d-none d-md-block">
            {/* Website */}
            {explore && (
              <Link to={to}>
                <div className="text-color-success wx-147 hx-40 d-flex align-items-center justify-content-center">
                  <Button
                    textclass="fonts-500 font-family-roboto-flex font-16 line-18 justify-content-center"
                    className="text-color-success wx-147 hx-40 d-flex align-items-center justify-content-center d-none d-md-block"
                    text={explore}
                    ui-button
                  />
                </div>
              </Link>
            )}
          </div>
        </div>
        <div className={`${ImgClass} col-lg-6 col-md-12 container-fluid`}>
          <img className="w-100" src={path} alt={"graph sheet"} />
        </div>
      </div>
    </div>
  );
};

export default GraphDataOnLeft;

GraphDataOnLeft.defaultProps = {
  path: "",
  heading: "",
  paragraph: "",
  className: "",
};
